






































































import {
    Component,
    Vue
} from 'vue-property-decorator';

import auth from '../common/auth';
import axios from '../common/api';
import { USER_SOURCE, DISPLAY_SOURCE } from '../common/const';
declare var $:any

const SOURCE_TEXT = '您是从哪里了解EssayDoctor的？'


@Component({
    components: {},
})
export default class Index extends Vue {


    form = {
        email:'',
        pwd:'',
        pwd2:'',
        verify_code:'',
        source: SOURCE_TEXT
    }
    sent:boolean = false
    read:boolean = false
    countdown:number = 0

    USER_SOURCE = USER_SOURCE

    DISPLAY_SOURCE = DISPLAY_SOURCE

    created(){
        document.title = '注册 - EssayDoctor 文书工作室'  

    }
    checkMail(){
        
    }
    sendVerify(){
        if(!this.form.email){
            this.$message.warning('请输入邮箱')
            return
        }
        axios.post('/sendverify',{email:this.form.email}).then(res=>{
            this.$message.success('邮件发送成功，请去邮箱查阅')
            this.countdown = 60
            let timer = setInterval(()=>{
                this.countdown--
                if(this.countdown<=0){
                    clearInterval(timer)
                }
            },1000)
            this.sent = true
            setTimeout(() => {
                this.$notify.info({
                    title:'',
                    message:'若您没有收到验证码，可能被您的邮箱服务商屏蔽，请查看邮箱垃圾箱，或者换个邮箱试试',
                    duration:0
                })
            }, 1000);

        }).catch(e=>{
            this.$message.error('邮件发送失败，请检查邮箱是否正确')
        })
    }
    submit(){
        console.log(this.read)
        if(!this.form.email){
            alert('请输入邮箱')
            return
        }
        if(!this.form.pwd){
            alert('请输入密码')
            return
        }
        if(this.form.pwd!==this.form.pwd2){
            alert('两次密码不一致')
            return
        }
        if(!this.form.verify_code){
            alert('请输入验证码')
            return
        }
        if(!this.form.source || this.form.source === SOURCE_TEXT){
            alert('请选择了解渠道')
            return
        }
        if(!this.read){
            alert('请同意服务协议')
            return
        }
        axios.post('/register', this.form).then(res=>{
            let ret = res.data
            if(ret === 'expired'){
                this.$message.error('验证码已过期')
            } else if(ret === 'invalid'){
                this.$message.error('验证码不正确')
            } else {
                this.$message.success('注册成功')
                // auth.setToken(ret)
                setTimeout(()=>{
                    location.replace('/login.html#/login')
                },1000)
            }
        })
    }


    openModal(){
        $("body").addClass("Dingzh");
		$(".thepagebgg").fadeIn(600);
		$(".JIaweixin").addClass("feirud");
    }
    closeModal(){
        $("body").removeClass("Dingzh");
		$(".thepagebgg").fadeOut(600);
		$(".JIaweixin").removeClass("feirud");
    }
}
